module.exports = __webpack_public_path__ + "static/error-bc6ff8986233daf394d99e7e3a430a84.mp3";